<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-manage-contributions">
  <div class="org-admin-manage-contributions--layout">
    <app-org-admin-sidebar class="org-admin-manage-contributions--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-manage-contributions--content">
      <app-page-header></app-page-header>
      <div class="manage-contributions-container">
        <!-- Filter Panel -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="contributionsData"
          [pagination]="pagination"
          [loading]="loading"
          [emptyMessage]="emptyMessage"
          [initialSortColumn]="initialSortColumn"
          [initialSortDirection]="initialSortDirection"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Permission Column (icon + content like dataset collection) -->
          <ng-template #permissionCell let-row>
            <div [ngClass]="getPermissionBadgeClass(row.permission)">
              <img
                *ngIf="row.permission && row.permission.toUpperCase() === 'RESTRICTED'"
                src="/filters/lock.svg"
                alt="Restricted"
                class="permission-badge-icon"
              />
              <img
                *ngIf="row.permission && (row.permission.toUpperCase() === 'OPEN' || row.permission.toUpperCase() === 'PUBLIC')"
                src="/filters/globe.svg"
                alt="Public"
                class="permission-badge-icon"
              />
              <img
                *ngIf="row.permission && row.permission.toUpperCase() === 'PRIVATE'"
                src="/filters/lock.svg"
                alt="Private"
                class="permission-badge-icon"
              />
              <span>{{ getPermissionLabel(row.permission) }}</span>
            </div>
          </ng-template>

          <!-- Custom Asset Status Column (Pascal case + chips theme) -->
          <ng-template #statusCell let-row>
            <div [ngClass]="getStatusChipClass(row.assetStatus)" class="contribution-chip">
              <span>{{ getStatusLabel(row.assetStatus) }}</span>
            </div>
          </ng-template>

          <!-- Custom Published On Column (DD-MMM-YYYY HH:MM IST; time in grey, smaller font) -->
          <ng-template #publishedOnCell let-row>
            <span>{{ getPublishedOnDatePart(row.publishedOn) }}</span>
            <span class="published-on-time">{{ getPublishedOnTimePart(row.publishedOn) }}</span>
          </ng-template>

          <!-- Custom Action Column (dropdown rendered in fixed overlay below) -->
          <ng-template #actionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn action-btn--primary" 
                type="button"
                appActionDropdownTrigger
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
              >
                <span class="action-btn-label">Action</span>
                <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </div>
          </ng-template>
        </app-table>
      </div>

      <!-- Fixed overlay: dropdown on top of table -->
      <div
        *ngIf="overlayPosition && openDropdownRow"
        class="action-dropdown-overlay"
        [style.top.px]="overlayPosition.top"
        [style.left.px]="overlayPosition.left"
        [style.min-width.px]="overlayPosition.width"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item">
            <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">View</button>
          </li>
          <li class="dropdown-item">
            <button type="button" class="dropdown-link" (click)="handleAction('modify', openDropdownRow)">Modify Asset</button>
          </li>
          <li class="dropdown-item">
            <button type="button" class="dropdown-link" (click)="handleAction('delete', openDropdownRow)">Remove Asset</button>
          </li>
        </ul>
      </div>

      <!-- Modify Asset Modal (same as Access Request page) -->
      <app-modal
        [(visible)]="showModifyModal"
        header="Modify Asset Metadata"
        [width]="'900px'"
        [showFooter]="false"
        (onCancel)="closeModifyModal()"
      >
        <div *ngIf="isLoadingAssetData" class="loading-container">
          <p>Loading asset data...</p>
        </div>
        <app-provider-preview-metadata
          *ngIf="!isLoadingAssetData && modifyAssetData"
          [editableMode]="true"
          [allowSaveWithoutDirty]="true"
          [assetData]="modifyAssetData"
          [assetType]="getAssetTypeForModify()"
          (formSubmit)="onModifyFormSubmit($event)"
          (formCancel)="onModifyFormCancel()"
        ></app-provider-preview-metadata>
      </app-modal>
    </div>
  </div>
</div>


